// import { createSelector } from 'reselect';

export const getShowRWDNavbar = state => state.getIn(['topBar', 'showRWDNavbar']);